import cx from 'classnames';

import {Transition} from '#component/util';

import {GraphProps} from './Graph.types';

import * as css from './Graph.css';

const DELTA_AGE_UPPER_THRESHOLD = 6;
const DELTA_AGE_LOWER_THRESHOLD = -6;

const getGraphSrc = (deltaAge = 0) => {
  if (deltaAge <= DELTA_AGE_LOWER_THRESHOLD) {
    return '/image/low-age-high-impact.svg';
  } else if (deltaAge >= DELTA_AGE_UPPER_THRESHOLD) {
    return '/image/high-age-high-impact.svg';
  }
  return '/image/same-age-high-impact.svg';
};

/* eslint-disable @next/next/no-img-element */
export const Graph = ({
  className,
  deltaAge = DELTA_AGE_LOWER_THRESHOLD,
  ...otherProps
}: GraphProps) => (
  <Transition.Child className={cx(css.transitionChild, className)} {...otherProps}>
    <img alt="Slow your TallyAge™ over time" className={css.graph} src={getGraphSrc(deltaAge)} />
    <img aria-hidden alt="" className={css.graphLabel} src="/image/label.svg" />
  </Transition.Child>
);
